// noinspection DuplicatedCode
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { Colors } from "../../../assets/Colors";
import { AccountPayableTable } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { useForm } from "../../../components/isRequired";
import { useMutation } from "@tanstack/react-query";
import { fetchGet } from "../../../fetchers";
import { toast } from "react-toastify";
import { maxPageGlobal } from "../../../assets/config";

const AccountPayable = ({}) => {
  let initialState = {
    Bulan: new Date(),
    BisnisUnitID: "U0002",
  };

  const validations = [];

  const { values, errors, touched, customHandler } = useForm(
    initialState,
    validations
  );

  const [data, setData] = useState(null);
  const [dataUpkeep, setDataUpkeep] = useState(null);
  const mutationData = useMutation((param) =>
    fetchGet("Accounting/AccountPayable", param)
  );
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [detail, setDetail] = useState({});
  const [count, setCount] = useState(maxPageGlobal);
  const [start, setStart] = useState(0);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [param, setParam] = useState({
    start: start,
    count: count,
    search: "",
    BisnisUnitID: "U0002",
    Bulan: (new Date().getMonth() + 1).toString(),
  });
  useEffect(() => {
    toast.info("Loading table!", {
      position: "top-center",
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: "light",
    });

    mutationData.mutate(
      {},
      {
        onSuccess: async (data, context) => {
          let calc = data?.count - 1;
          if (calc === 0) {
            calc = 1;
          }

          if (calc % count === 0) {
            calc = calc + 1;
          }

          let tempMaxPage = data.data ? Math.ceil(calc / count) : 1;
          setMaxPage(tempMaxPage);
        },
      }
    );
  }, [param]);

  const header = [
    { name: "No. MSR", key: "NamaKaryawan", modifiers: "Text" },
    { name: "No. Purchase Order", key: "NamaKaryawan", modifiers: "Text" },
    { name: "No. Bast/Document", key: "NamaKaryawan", modifiers: "Text" },
    { name: "Tanggal Bast", key: "TanggalIzin", modifiers: "Number" },
    { name: "No. Bukti Pembayaran", key: "Golongan", modifiers: "Text" },
    {
      name: "Tanggal Pembayaran",
      key: "JumlahHariKerjaIzin",
      modifiers: "Number",
    },
    { name: "TOP", key: "JumlahHariKerjaIzin", modifiers: "Number" },
    {
      name: "Tanggal Jatuh Tempo",
      key: "JumlahHariKerjaIzin",
      modifiers: "Number",
    },
    { name: "Nominal", key: "JumlahHariKerjaIzin", modifiers: "Number" },
    { name: "0-30", key: "JumlahHariKerjaIzin", modifiers: "Number" },
    { name: "31-60", key: "JumlahHariKerjaIzin", modifiers: "Number" },
    { name: "61-90", key: "JumlahHariKerjaIzin", modifiers: "Number" },
    { name: ">90", key: "JumlahHariKerjaIzin", modifiers: "Number" },
  ];

  const filterData = (event) => {
    const filtered = dataUpkeep.filter(({ NamaKaryawan }) =>
      NamaKaryawan.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setData(filtered);
  };
  const filterApi = () => {
    setParam({
      start: start,
      count: count,
      search: "",
      BisnisUnitID: values.BisnisUnitID,
      Bulan: (new Date(values.Bulan).getMonth() + 1).toString(),
    });
  };

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>
        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                <div className="flex flex-col items-center content-center ">
                  <AccountPayableTable
                    data={mutationData.data}
                    header={header}
                    menuController={filterData}
                    name={"Nama"}
                    title={"Report Jurnal"}
                  />
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountPayable;
